import PropTypes from "prop-types";
import React from "react";
import { Field } from "formik";
import Button from "../../components/Button/Button";
import Button2 from "../../components/Button/Button2";
import FormSelect2 from "../../components/FormSelect/FormSelect2";
import { uploadCompanyImage } from "../../utils/cloudinarySignUp";
import Download from "../../../src/assets/assets/download.svg";

const companyCategories = [
  {
    id: "1",
    name: "Banks",
    disabled: false,
  },
  {
    id: "2",
    name: "Other Financial Institution's (OFI)",
    disabled: false,
  },
  {
    id: "3",
    name: "Mobile Money Operators (MMO)",
    disabled: false,
  },
  {
    id: "4",
    name: "Payment Solution Service Providers (PSSP)",
    disabled: false,
  },
  {
    id: "5",
    name: "Billers",
    disabled: false,
  },
  {
    id: "6",
    name: "Aggregator",
    disabled: false,
  },
  {
    id: "7",
    name: "Payment Solution Terminal Providers (PTSP)",
    disabled: false,
  },
];

export const SignUpForm3 = (props) => {
  const {
    page2,
    page4,
    img_url,
    block3,
    error,
    loaded,
    assignUrl,
    removeFile,
  } = props;

  const showWidget = () => {
    uploadCompanyImage(assignUrl, ["png", "jpeg"]);
  };

  const category = companyCategories;
  return (
    <div className="form-1">
      <div className="form-input">
        <Field name="category">
          {(val) => (
            <FormSelect2
              id="formselect"
              options={category}
              label="Business Category"
              placeholder="Select Category"
              {...val}
            />
          )}
        </Field>
      </div>

      <div className={loaded ? "file-uploaded" : "file-input"}>
        {!loaded ? (
          <span
            onClick={showWidget}
            className={loaded ? "file-uploaded" : "file"}
            type="button"
          >
            <img src={Download} alt="download" />
          </span>
        ) : (
          <div className="uploaded-files">
            <img src={img_url} alt="logo" />
            <span className="signup-delete-icon" onClick={() => removeFile()}>
              &#x2716;
            </span>
          </div>
        )}
        {!(loaded || error !== "") ? (
          <label className="file-label" onClick={showWidget}>
            UPLOAD COMPANY LOGO <br />{" "}
            <span id="drag">
              click to <span id="browse">UPLOAD </span> files
            </span>
          </label>
        ) : (
          ""
        )}
        {error !== "" && <p className="errors">{error}</p>}
      </div>
      <p className="warning-image">
        Only png, jpeg and jpg formats are allowed with a max file size of 1MB
      </p>

      <div className="form-input-button">
        <Button2 width="45%" height="45px" word={"Back"} onClick={page2} />
        <Button
          type="button"
          width="45%"
          height="45px"
          word={"Proceed"}
          onClick={page4}
          disabled={img_url === "" || block3}
        />
      </div>
    </div>
  );
};

SignUpForm3.propTypes = {
  assignUrl: PropTypes.any,
  block3: PropTypes.any,
  error: PropTypes.string,
  img_url: PropTypes.string,
  loaded: PropTypes.any,
  page2: PropTypes.any,
  page4: PropTypes.any,
  removeFile: PropTypes.func
}

export default SignUpForm3;
